import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Download } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { api, downloadCsv, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { fmtDateTime } from "@/lib/format";
import { PageHeader, Empty } from "@/components/kit";

const REPORTS = [["clients", "Clientes"], ["transactions", "Transações financeiras"], ["orders", "Ordens"], ["positions", "Posições"], ["audit", "Trilha de auditoria"]];

export default function AdminReports() {
  const { user } = useAuth();
  const can = (p) => user.is_super || (user.permissions || []).includes(p);
  const [audit, setAudit] = useState([]);
  const [outbox, setOutbox] = useState([]);
  useEffect(() => {
    api.get("/admin/audit").then((r) => setAudit(r.data)).catch(() => {});
    if (can("clients")) api.get("/admin/outbox").then((r) => setOutbox(r.data)).catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const dl = async (k) => { try { await downloadCsv(`/admin/export/${k}`, `traderepublic_${k}.csv`); toast.success("Relatório exportado"); } catch (e) { toast.error(errMsg(e)); } };
  return (
    <div data-testid="admin-reports-page">
      <PageHeader eyebrow="Relatórios" title="Relatórios, auditoria e e-mails" desc="Exporte relatórios autorizados em CSV. Toda exportação é registrada na trilha de auditoria." />
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 mb-6">
        {REPORTS.map(([k, l]) => (
          <button key={k} onClick={() => dl(k)} className="surface p-5 text-left hover:border-primary transition-colors" data-testid={`export-${k}`}>
            <Download className="h-5 w-5 text-primary" /><div className="mt-3 font-semibold">{l}</div><div className="text-xs text-muted-foreground">CSV (separador ;)</div>
          </button>))}
      </div>
      <Tabs defaultValue="audit">
        <TabsList><TabsTrigger value="audit" data-testid="tab-audit">Auditoria</TabsTrigger>{can("clients") && <TabsTrigger value="outbox" data-testid="tab-outbox">Caixa de saída (e-mails simulados)</TabsTrigger>}</TabsList>
        <TabsContent value="audit"><div className="surface divide-y divide-border">
          {audit.length === 0 && <Empty text="Sem registros." />}
          {audit.map((a) => <div key={a.id} className="flex flex-wrap gap-3 p-4 text-sm"><span className="text-xs text-muted-foreground w-36">{fmtDateTime(a.created_at)}</span><span className="num text-primary">{a.action}</span><span>{a.actor_email}</span><span className="text-xs text-muted-foreground">{a.target}</span></div>)}
        </div></TabsContent>
        <TabsContent value="outbox"><div className="surface divide-y divide-border" data-testid="outbox-list">
          {outbox.length === 0 && <Empty text="Nenhum e-mail." />}
          {outbox.map((m) => (
            <div key={m.id} className="p-4 text-sm"><div className="flex justify-between gap-3"><span className="font-semibold">{m.subject}</span><span className="text-xs text-muted-foreground">{fmtDateTime(m.created_at)}</span></div>
              <div className="text-xs text-muted-foreground">Para: {m.to} · SIMULADO</div>
              {m.link && <a href={m.link} className="text-xs text-primary break-all underline">{m.link}</a>}</div>))}
        </div></TabsContent>
      </Tabs>
    </div>
  );
}
